/**
 * Cost Centers Catalog Hook
 */

import { useState, useEffect } from 'react';
import { costCentersCatalogService } from '../costCenters.service.ts';
import type { CostCenter } from '../costCenters.types.ts';


interface UseCostCentersResult {
  costCenters: CostCenter[];
  loading: boolean;
  error: string | null;
}

export function useCostCenters(): UseCostCentersResult {
  const [costCenters, setCostCenters] = useState<CostCenter[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    void (async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await costCentersCatalogService.getCostCenters();

        if (!isMounted) return;

        if (response.success && response.data) {
          setCostCenters(response.data);
        } else if (response.error) {
          setError(response.error.description || 'Error loading cost centers');
        }
      } catch (catchError) {
        if (!isMounted) return;
        setError(catchError instanceof Error ? catchError.message : 'Unknown error');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { costCenters, loading, error };
}
